import { FAIR_PRICING_SERVICE_FEE_RATE, FAIR_PRICING_VARIANT } from '@constants/fairPricing';

import HotelApi from '@customTypes/hotel-api';
import HotelDetails from '@customTypes/hotel-details';
import { PopularHotel } from '@customTypes/popular-hotel-data';
import Product from '@customTypes/product';

export function getProductPriceForGuestType(
  product: Product,
  guestType: 'adult' | 'child',
  showFairPricing: boolean,
) {
  const price = guestType === 'adult' ? product.adult_price : product.children_price;

  if (showFairPricing) {
    if (FAIR_PRICING_VARIANT === 'variant1') {
      return parseFloat(price) * (1 + FAIR_PRICING_SERVICE_FEE_RATE);
    }

    if (FAIR_PRICING_VARIANT === 'variant2') {
      return price;
    }
  }

  return price;
}

export function ShouldShowFairPricingFromHotelAPI(h: HotelApi) {
  const rules = [
    (api: HotelApi) => api.code?.toLowerCase() === 'ca' && api.state.toLowerCase() === 'california',
  ];
  return rules.some((rule) => rule(h));
}

export function ShouldShowFairPricingFromHotelDetails(h: HotelDetails) {
  const rules = [
    (details: HotelDetails) =>
      details.country_code.toLowerCase() === 'us' &&
      details.state_name.toLowerCase() === 'california',
  ];
  return rules.some((rule) => rule(h));
}

export function ShouldShowFairPricingFromPopularHotel(h: PopularHotel) {
  const rules = [
    (details: PopularHotel) =>
      details.code?.toLowerCase() === 'ca' && details.state_name.toLowerCase() === 'california',
  ];
  return rules.some((rule) => rule(h));
}

export function ShouldShowFairPricingFromHotelType(h: any) {
  if (h.country_code !== undefined && h.state_name !== undefined) {
    return ShouldShowFairPricingFromHotelDetails(h as HotelDetails);
  }

  if (h.code !== undefined && h.state_name !== undefined) {
    return ShouldShowFairPricingFromPopularHotel(h as PopularHotel);
  }

  if (h.code !== undefined && h.state !== undefined) {
    return ShouldShowFairPricingFromHotelAPI(h as HotelApi);
  }

  // better safe than sorry? default show fair pricing
  return true;
}
